var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[(_vm.isEdit)?_c('science-edit',{attrs:{"close":_vm.handleClose,"form":_vm.itemForm,"id":_vm.reviseId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }